/** Область кадра в пикселях исходной картинки (как её отдаёт react-easy-crop). */
export interface CropArea {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

/** Сторона готового аватара: хватает для крупной карточки, файл — десятки килобайт. */
export const AVATAR_SIZE = 512;

function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      resolve(image);
    };
    image.onerror = () => {
      reject(new Error('image'));
    };
    image.src = url;
  });
}

/** Центральный квадрат — если кадр не успели выбрать. */
export function centerSquare(width: number, height: number): CropArea {
  const side = Math.min(width, height);
  return { x: (width - side) / 2, y: (height - side) / 2, width: side, height: side };
}

/**
 * Вырезать квадрат из картинки и сжать в JPEG `AVATAR_SIZE`×`AVATAR_SIZE`. JPEG, а не WebP:
 * Safari 16 не умеет кодировать WebP на canvas.
 */
export async function cropAvatar(url: string, area: CropArea | null): Promise<File> {
  const image = await loadImage(url);
  const crop = area ?? centerSquare(image.naturalWidth, image.naturalHeight);
  const canvas = document.createElement('canvas');
  canvas.width = AVATAR_SIZE;
  canvas.height = AVATAR_SIZE;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('canvas');
  context.imageSmoothingQuality = 'high';
  context.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, AVATAR_SIZE, AVATAR_SIZE);
  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', 0.9);
  });
  if (!blob) throw new Error('canvas');
  return new File([blob], 'avatar.jpg', { type: 'image/jpeg' });
}
